import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const adminApi = {
  // Dashboard
  getDashboard: () => axios.get(`${API}/admin/dashboard`),

  // Organisations
  getOrganisations: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') qs.append(k, v); });
    return axios.get(`${API}/admin/organisations?${qs}`);
  },
  createOrganisation: (data) => axios.post(`${API}/admin/organisations`, data),
  getOrganisation: (id) => axios.get(`${API}/admin/organisations/${id}`),
  updateOrganisation: (id, data) => axios.patch(`${API}/admin/organisations/${id}`, data),

  // Users
  getUsers: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') qs.append(k, v); });
    return axios.get(`${API}/admin/users?${qs}`);
  },
  createUser: (data) => axios.post(`${API}/admin/users`, data),
  getUser: (id) => axios.get(`${API}/admin/users/${id}`),
  updateUser: (id, data) => axios.patch(`${API}/admin/users/${id}`, data),
  forcePasswordReset: (id, reason) => axios.post(`${API}/admin/users/${id}/force-password-reset`, { reason }),
  resetMfa: (id, reason) => axios.post(`${API}/admin/users/${id}/reset-mfa`, { reason }),

  // Monitoring
  getMonitoringErrors: () => axios.get(`${API}/admin/monitoring/errors`),

  // Impersonation
  startImpersonation: (orgId, reason) => axios.post(`${API}/admin/impersonate/${orgId}`, { reason }),
  endImpersonation: () => axios.post(`${API}/admin/end-impersonation`, {}),

  // Audit Log
  getAuditLog: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') qs.append(k, v); });
    return axios.get(`${API}/admin/audit-log?${qs}`);
  },
  exportAuditLog: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') qs.append(k, v); });
    return `${API}/admin/audit-log/export?${qs}`;
  },

  // Settings
  getSettings: () => axios.get(`${API}/admin/settings`),
  updateSettings: (data) => axios.patch(`${API}/admin/settings`, data),
  // Leads
  getLeads: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') qs.append(k, v); });
    return axios.get(`${API}/admin/leads?${qs}`);
  },
  updateLeadStatus: (id, status) => axios.patch(`${API}/admin/leads/${id}`, { status }),
  resendConfirmation: (id) => axios.post(`${API}/contact/leads/${id}/resend-confirmation`),

  // Onboarding
  getUserOnboarding: (userId) => axios.get(`${API}/admin/onboarding/${userId}`),

  // Billing overrides
  grantAccess: (orgId, plan, days) => axios.post(`${API}/admin/organisations/${orgId}/grant-access`, { plan, days }),
  revokeAccess: (orgId) => axios.post(`${API}/admin/organisations/${orgId}/revoke-access`),
  extendPeriod: (orgId, days) => axios.post(`${API}/admin/organisations/${orgId}/extend-period`, { days }),
};

export default adminApi;
